exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_QRCode_1xUQzJK9Qaio2lRXwUD93Q {\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff;\n  overflow: hidden;\n\n}\n\n.IA_QRCodeImage_3X6FxHvKyxPSuGSl2CKtNL {\n  float: left;\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}", ""]);

// Exports
exports.locals = {
	"IA_QRCode": "IA_QRCode_1xUQzJK9Qaio2lRXwUD93Q",
	"IA_QRCodeImage": "IA_QRCodeImage_3X6FxHvKyxPSuGSl2CKtNL"
};